import Model from '@/models/Model.js';

export default class MeetingParticipant extends Model {
    static entity = 'meeting_participants';

    static fields() {
        return {
            id: this.attr(null),
            meeting_id: this.attr(null),
            user_id: this.attr(null),
            based_on_guess: this.attr(null),
            meeting_user_id: this.attr(null),
            provider_participant_id: this.attr(null),
            provider_user_id: this.attr(null),
            provider_email: this.attr(null),
            provider_name: this.attr(null),
            first_join_time: this.attr(null),
            last_leave_time: this.attr(null),
            total_duration: this.attr(null),

            ...super.fields(),

            meeting: this.belongsTo('meetings', 'meeting_id'),
            user: this.belongsTo('users', 'user_id'),
            meeting_user: this.belongsTo('meeting_users', 'meeting_user_id'),
            logs: this.hasMany('meeting_participant_logs', 'meeting_participant_id'),
            comments: this.hasMany('meeting_participant_comments', 'meeting_participant_id'),
        };
    }

    get name() {
        if (!this.user_id || !this.user) {
            return this.provider_name;
        }

        return this.user.name;
    }

    get total_duration_minutes() {
        return Math.round(this.total_duration / 60);
    }
}
